module.exports = __webpack_public_path__ + "img/xiaoshou-h.4614ce8c.svg";